<template>
  <div id="navse" class="navbar-wrapper"
    data-aos="fade-in" data-aos-once="true"
    :class="[ $route.name !== 'landing' ? 'not-landing' : '' ]">
    <div class="container navbar-row first is-fluid"
      style="margin-left:0;margin-right:0;"
      data-aos="fade-in" data-aos-once="true">
      <div class="container navbar-wrapper-inner"
        data-aos="fade-in" data-aos-once="true">
        <div class="columns is-gapless navbar-full first is-mobile">

          <div class="column is-3 navbar-brand" align="left" style="">
            <a class="navbar-logo" href="/">
              <img src="../assets/logo.png" width="230"
                class="img-responsive logo-1" style="max-width:230px;padding:20px;margin-top:16px;" />
            </a>
          </div>

          <div class="column is-9 column-link is-hidden-mobile has-text-right">
            <div class="columns is-gapless navbar-row second is-fluid">

              <div v-for="(nav, navIndex) in navItems"
                :key="nav.name"
                class="column column-link is-hidden-mobile"
                :class="{
                  'has-text-centered': true,
                  'is-active': $route.name === nav.name
                }">

                <dropdown
                  :visible="nav.subnavOpen || false"
                  :position="dropdownPositions"
                  :animation="'ani-slide-y'"
                  @positioned="onDropdownPosition($event, nav.offset, navIndex)">

                  <a :href="[
                      nav.section ?
                      ('/?anchor=' + nav.section) :
                      nav.url ? nav.url :
                      (nav.path ? nav.path : '#')]"
                    @click="[ nav.section ?
                      onScrollTo($event, 'landing', nav.section) :
                      nav.url ?
                      () => {} :
                      (nav.path ?
                      onClick($event, nav.path, nav, nav) :
                      $event.preventDefault())]"
                    @mouseenter="onMouseOverSubnav($event, nav.subnav, nav)"
                    @mouseleave="onMouseOutSubnav($event, nav.subnav, nav)"
                    :target="nav.url ? '_blank' : undefined"
                    class="nav">
                    <dropdown :visible="nav.subnavOpen || false"  :position="dropdownPositions">
                      {{ nav.label }}
                      <span v-if="(nav.subnav && nav.subnav.length > 0)" style="margin-left:6px;">
                        <!-- <i class="fa fa-chevron-right"></i> -->
                        <i class="el-icon-arrow-right"></i>
                      </span>
                    </dropdown>
                  </a>

                  <div
                    slot="dropdown" class="dropdown-wrapper"
                    @mouseenter="onMouseOverSubnav($event, nav.subnav, nav)"
                    @mouseleave="onMouseOutSubnav($event, nav.subnav, nav)"
                    style="border:1px solid lightgray;">

                    <div v-for="(navSub, subindex) in nav.subnav"
                      :key="`${subindex}`"
                      class="dropdown-item has-text-left">
                      <a :href="[
                          navSub.section ?
                          ('/?anchor=' + navSub.section) :
                          (navSub.path ? navSub.path : '#')]"
                        @click="[ navSub.section ?
                          onScrollTo($event, 'landing', navSub.section) :
                          (navSub.path ?
                          onClick($event, navSub.path, navSub, nav) :
                          $event.preventDefault())]"
                        :class="{ 'nav-item-link': true, active : $route.name === navSub.name }"
                        :style="[navSub.style, { backgroundColor: 'white' }]">

                        <div class="dropdown-item-inner"
                          :style="navSub.styleInner">
                          {{ navSub.label || '(null)' }}
                        </div>

                      </a>
                    </div>

                  </div>
                </dropdown>

              </div>

            </div>
          </div>

          <div class="column is-9 navbar-menu" @click="onToggle()"
            data-aos="zoom-in" data-aos-once="true">
            <div class="control-menu" :class="{ active : showNav }">
              <span></span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- <div v-else style="height:120px;">
      &nbsp;
    </div> -->
    <!-- <div class="container navbar-row second is-fluid" style="margin-left:0;margin-right:0;">
      <div class="container">
        <div class="columns navbar-full second is-gapless is-mobile is-hidden-mobile" style="overflow:hidden;">
          <div v-for="(nav) in navItems"
            :key="nav.name"
            class="column column-link is-hidden-mobile"
            :class="{
              'has-text-centered': true,
              'is-active': $route.name === nav.name
            }">
            <a :href="`${nav.path}`">
              {{ nav.label }}
            </a>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import _ from 'lodash'
import Dropdown from 'vue-my-dropdown'
import EventBus from '@/controllers/EventBus'
// import Site from '@/apis/site'
export default {
  name: 'navbarfull',
  props: ['toggle'],
  components: {
    'Dropdown': Dropdown
  },
  data () {
    return {
      showNav: false,
      navItems: EventBus.getNav(),
      // navCurr: undefined,
      // navDebounce: undefined,
      dropdownPositions: ['center', 'bottom', 'center', 'top'],
    }
  },
  computed: {
  },
  watch: {
    toggle: function (val) {
      this.showNav = val
    },
    '$route.name': function (val) {
      // only do this when overlay mode and route change
      if (this.showNav) {
        this.onToggle()
      }
    }
  },
  beforeCreate () {
    // in this function
    // modification to data will not invoke
  },
  created () {
    // this.navDebounce = _.debounce(this.onMouseOutSubnavEvent, 200)
  },
  beforeMount () {
  },
  async mounted () {
    // try {
    //   let data
    //   data = await Site.infos()
    //   console.log('-- all infos', data)
    //   // data = await Site.infoNamed('navbar-phone')
    //   // if (data && data[0] && data[0].content) {
    //   //   this.phone = data[0].content
    //   // } else {
    //   //   this.phone = undefined
    //   // }
    //   // data = await Site.infoNamed('navbar-fax')
    //   // if (data && data[0] && data[0].content) {
    //   //   this.fax = data[0].content
    //   // } else {
    //   //   this.fax = undefined
    //   // }
    //   // data = await Site.infoNamed('navbar-address')
    //   // if (data && data[0] && data[0].content) {
    //   //   this.address = data[0].content
    //   // } else {
    //   //   this.address = undefined
    //   // }
    // } catch (error) {
    //   this.phone = undefined
    //   this.fax = undefined
    //   this.address = undefined
    //   console.log('info error', error)
    // }
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    onToggle: function () {
      this.showNav = !this.showNav
      var className = 'modal-open'
      var root = document.documentElement
      root.className = ''
      if (this.showNav) {
        root.className += className
      } else {
        root.className -= className
      }
      this.$emit('onToggle', this.showNav)
    },

    onMouseOverSubnav ($event, subnav, nav) {
      // try not use visible, only singular, use subnavOpen for multiple dropdown
      // if (subnav) {
      //   this.visible = true
      // }
      if (nav) {
        nav.subnavOpen = true
      }
    },

    onMouseOutSubnav ($event, subnav, nav) {
      // try not use visible, only singular, use subnavOpen for multiple dropdown
      // if (subnav) {
      //   this.visible = false
      // }
      if (nav) {
        nav.subnavOpen = false
        // this.navCurr = nav
        // if (this.navDebounce) {
        //   this.navDebounce()
        // }
      }
    },

    // onMouseOutSubnavEvent () {
    //   if (this.navCurr) {
    //     this.navCurr.subnavOpen = false
    //   }
    // },

    onDropdownPosition ($event, offset, index) {
      // console.log('onDropdownPosition', { event: $event, offset, index })
      this.dropdownPosition = $event
      $event.top = '89px !important'
      if (offset && offset.top !== undefined) {
        if ($event.top && $event.top.match(/^([0-9])+px$/g)) {
          let val = parseFloat($event.top.replace(/(px)/g, ''))
          val += offset.top
          $event.top = `${val}px !important`
        }
      }
      if (offset && offset.left !== undefined) {
        if ($event.left && $event.left.match(/^([0-9])+px$/g)) {
          // console.log('-- before', $event.left)
          let val = parseFloat($event.left.replace(/(px)/g, ''))
          val += offset.left
          // console.log('-- after', val)
          $event.left = `${val}px !important`
        }
      }
      if (offset && offset.right !== undefined) {
        if ($event.right && $event.right.match(/^([0-9])+px$/g)) {
          let val = parseFloat($event.right.replace(/(px)/g, ''))
          val += offset.right
          $event.right = `${val}px !important`
        }
      }
    },

    onDropdown2Position ($event, info, index) {
      // console.log('onDropdown2Position', { event: $event, info, index })
      this.dropdownPosition = $event
      if (info && info.top !== undefined && index !== undefined) {
        let offset = 2
        let perRow = 40
        let total = offset + ((index) * perRow)
        $event.top = `${total}px !important`
      }
      // if (info && info.top !== undefined) {
      //   $event.top = `${info.top}px !important`
      // }
      if (info && info.left !== undefined) {
        $event.left = `${info.left}px !important`
      }
      if (info && info.right !== undefined) {
        $event.right = `${info.right}px !important`
      }
    },

    onClick: function ($event, path, navItem, navParentItem) {
      $event.preventDefault()
      // if (navItem && !navItem.subnav && navItem.hasOwnProperty('subnavOpen')) {
      //   this.$set(navItem, 'subnavOpen', false)
      // }
      // dismiss parent
      if (navParentItem && navParentItem.subnav && navParentItem.hasOwnProperty('subnavOpen')) {
        this.$set(navParentItem, 'subnavOpen', false)
      }
      if (typeof path === 'string' && path.length > 0 && path[0] !== '/') {
        path = `/${path}`
      }
      this.$router.push(path)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";
@import "./NavBarSettings.scss";

$navbar-color: transparent;
$navbar-overlay-color: rgba(255,255,255,0.8);

html.modal-open {
  .navbar-wrapper {
    background-color: $navbar-overlay-color;
  }
}

.navbar-wrapper {
  background-color: $navbar-color;
  &.not-landing {
    // background-color: $color-primary-blue;
  }
  &-inner {
    background-color: transparent; // main navbar-full color
  }
}

#navse {
  z-index: 20;
  // pointer-events: none;
  // padding-left: 0.75rem;
  // padding-right: 0.75rem;
  @media screen and (min-width: $tablet) {
    // pointer-events: auto;
  }

  .navbar-row {
    &.first {
      background-color: $navbar-overlay-color;

      // only for desktop
      @media screen and (min-width: $tablet) {
        background-color: white;
      }
    }

    &.second {
      background-color: $navbar-overlay-color;

      // only for desktop
      @media screen and (min-width: $tablet) {
        background-color: transparent; // menu-color
      }
    }
  }

  .navbar-full {
    height: $navbar-height-row-1 !important;
    // padding-left: 0.75rem !important;
    // padding-right: 0.75rem !important;
    margin-bottom: 0 !important;

    // @media screen and (max-width: $tablet - 1) {
    //   height: fit-content;
    // }

    &.first {
    }

    &.second {
      height: $navbar-height-row-2 !important;
    }

    align-items: center;
    text-align: center;

    // this to workaround top bar positioning
    // position: absolute;
    // top: 0;
    // right: 0;
    // width: 40%;
    // this to workaround top bar positioning

    // background-color:rgba(0,0,0,0.5);
    @media screen and (min-width: $tablet) {
    }

    // pointer-events: none;
    @media screen and (min-width: $tablet) {
      height: 80px;
      // pointer-events: auto;
    }

    a.navbar-logo {
      .logo-1 {
        vertical-align: middle;
        max-width: auto;
        padding: 10px;
        padding-left: 0;

        @media screen and (max-width: $desktop - 1) {
          width: 280px;
          padding: 5px;
          padding-left: 0;
        }

        @media screen and (min-width: $desktop) {
          width: 340px;
          // padding: 15px;
        }
      }
    }

    .column {
      // padding: 0.75rem;

      &.is-active {
        a {
          background-color: $color-primary-green; // text-color
          color: white; // menu-color
          &:hover {
            color: $color-primary-yellow;
          }
        }
      }

      a {
        padding: 0.78rem;
        display: inline-block;

        // background-color: red;
        font-family: $font-family-header;
        color: black; // text-color
        // font-weight: bold;
        // letter-spacing: 0.1em;
        // text-transform: uppercase;
        width: 100%;
        &.navbar-logo {
          width: fit-content;
          padding-left: 0;
        }

        // padding: 10px;
        // font-size: 1.0rem;
        // @media screen and (max-width: $desktop - 1) {
        //   font-size: 1.0em;
        // }

        &:hover {
          color: $color-primary-green;
        }

        // @media screen and (min-width: $desktop) {
        //   padding: 10px;
        // }
        //
        // @media screen and (min-width: $fullhd) {
        //   padding: 20px;
        // }

        &.fa {
          font-size: 1.4rem;
          padding: 8px;

          &:last-child {
            padding-right: 30px;
          }
        }

        // col min-height
        // &.nav {
        //   min-height: 60px;
        // }
      }

      &.navbar-brand,
      &.navbar-menu {
        padding: 0px;
        margin: 0px;
      }

      &.navbar-menu {
        @media screen and (min-width: $tablet) {
          margin-left: 20px;
        }
      }
    }

    .columns {
      height: 100%;
    }
  } // end navbar-full

  .navbar-menu {
    height: 100%;
    margin: 0px;
    padding: 0px;
    margin-top: 5px;
    pointer-events: auto;
    box-shadow: 0 0 0;

    @media screen and (min-width: $tablet) {
      display: none;
    }

    // abnormal fix on resizing back and forth
    html.modal-open & {

      @media screen and (min-width: $tablet) {
        display: inherit;
      }
    }

    // cursor: pointer;
    // pointer-events: none;
    // @media screen and (min-width: $desktop) {
    //   pointer-events: auto;
    // }

    $menu-icon-color: $color-black;

    & .control-menu {
      cursor: pointer;
      padding: 8px 25px 16px 0px;
      // left: calc(50% - 12px);
      position: absolute;
      top: 46px;
      right: 30px;

      & span {

        &, &:before, &:after {
          height: 2px;
          display: block;
          border-radius: 1px;
          background: $color-white;
          border-bottom: 2px solid $menu-icon-color;
          position: absolute;
          // top: 45%;
          // right: 15px;
          width: 25px;
          display: block;
          content: '';
          transition: all 200ms ease-in-out;

          @media screen and (min-width: $tablet) {
            height: 2px;
            width: 30px;
            top: 50%;
          }
        }

        &:before, &:after {
          right: 0px;
          width: 20px;

          @media screen and (min-width: $tablet) {
            width: 25px;
          }
        }

        &:before {
          top: -6px;

          @media screen and (min-width: $tablet) {
            top: -8px;
          }
        }

        &:after {
          top: 6px;

          @media screen and (min-width: $tablet) {
            top: 8px;
          }
        }
      }
    }

    & .active span {
      background-color: transparent;
      border-bottom: 0px;

      &:before, &:after {
        top: 0;
        right: 20px; // suppose to adjusting to same position
      }

      &:before {
        transform: rotate(45deg);
        border-bottom: 2px solid $menu-icon-color;
      }

      &:after {
        transform: rotate(-45deg);
        border-bottom: 2px solid $menu-icon-color;
      }
    }
  }
}

</style>
